export const enum FeedbackType {
  General = "general",
  Module = "module",
  ExamQuestion = "exam-question"
}

export interface GeneralFeedbackI {
  feedbackCategory: string;
  feedbackText: string;
  userId: string;
  accountType?: string;
  browser: string;
  appVersion: string;
}

export interface ExamQuestionFeedbackI extends GeneralFeedbackI, WithinCourseI {
  questionId: string;
  sectionId: string;
  submittedAnswer?: string;
  maxMark?: number;
  autoMark?: number;
  selfMark?: number;
  teacherMark?: number;
}

export interface ModuleFeedbackI extends GeneralFeedbackI, WithinCourseI {
  sectionId: string;
  contentId: string;
  moduleId: string;
}

export interface WithinCourseI {
  courseId: string;
}

export type AnyFeedback =
  | GeneralFeedbackI
  | ExamQuestionFeedbackI
  | ModuleFeedbackI;
